import api from './api';

/**
 * Get all categories
 * @returns {Promise} Array of categories
 */
export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data.data;
};
